import {
  SectionElement,
  defineElement,
  onClick,
  queryAll
} from "./chunk-DNDL4K7L.js";
import {
  __decorateClass
} from "./chunk-RGTSXKO2.js";

// src/sections/common-main-product/common-main-product.ts
var COLLAPSED_HEIGHT = 640;
var CommonMainProduct = class extends SectionElement {
  constructor() {
    super(...arguments);
    this.handleResize = () => {
      var _a;
      return (_a = this.panels) == null ? void 0 : _a.forEach((panel) => this.syncCollapse(panel));
    };
  }
  connectedCallback() {
    var _a;
    this.resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        var _a2;
        this.syncCollapse((_a2 = entry.target.closest("[data-tab-panel]")) != null ? _a2 : void 0);
      });
    });
    window.addEventListener("resize", this.handleResize);
    this.setupCollapse((_a = this.panels) == null ? void 0 : _a[0]);
  }
  setupCollapse(panel) {
    var _a, _b;
    if (!panel)
      return;
    const content = panel.querySelector("[data-description-content]");
    const showMore = panel.querySelector("[data-show-more]");
    if (!content || !showMore)
      return;
    (_b = this.resizeObserver) == null ? void 0 : _b.observe((_a = content.firstElementChild) != null ? _a : content);
    this.syncCollapse(panel);
  }
  syncCollapse(panel) {
    var _a, _b;
    if (!panel || panel.classList.contains("hidden"))
      return;
    const content = panel.querySelector("[data-description-content]");
    const showMore = panel.querySelector("[data-show-more]");
    if (!content || !showMore)
      return;
    const varName = window.matchMedia("(min-width: 1024px)").matches ? "--collapse-height-desktop" : "--collapse-height-mobile";
    const collapsedHeight = parseInt(getComputedStyle(content).getPropertyValue(varName)) || COLLAPSED_HEIGHT;
    const overflows = content.scrollHeight > collapsedHeight + 1;
    if (!overflows) {
      content.classList.remove("is-collapsed");
      showMore.classList.add("hidden");
      return;
    }
    showMore.classList.remove("hidden");
    const userExpanded = showMore.dataset.userExpanded === "true";
    content.classList.toggle("is-collapsed", !userExpanded);
    showMore.setAttribute("aria-expanded", String(userExpanded));
    showMore.textContent = userExpanded ? (_a = showMore.dataset.lessLabel) != null ? _a : "" : (_b = showMore.dataset.moreLabel) != null ? _b : "";
  }
  handleTabClick(elm) {
    var _a, _b;
    const index = elm.dataset.tab;
    (_a = this.tabs) == null ? void 0 : _a.forEach((tab) => tab.dataset.tab === index ? tab.setAttribute("data-active", "") : tab.removeAttribute("data-active"));
    (_b = this.panels) == null ? void 0 : _b.forEach((panel) => {
      if (panel.dataset.tabPanel === index) {
        panel.classList.remove("hidden");
        this.setupCollapse(panel);
      } else {
        panel.classList.add("hidden");
      }
    });
  }
  handleShowMoreClick(elm) {
    var _a, _b, _c;
    const content = (_a = elm.closest("[data-tab-panel]")) == null ? void 0 : _a.querySelector("[data-description-content]");
    if (!content)
      return;
    const collapsed = content.classList.toggle("is-collapsed");
    elm.dataset.userExpanded = String(!collapsed);
    elm.setAttribute("aria-expanded", String(!collapsed));
    elm.textContent = collapsed ? (_b = elm.dataset.moreLabel) != null ? _b : "" : (_c = elm.dataset.lessLabel) != null ? _c : "";
  }
  disconnectedCallback() {
    var _a;
    (_a = this.resizeObserver) == null ? void 0 : _a.disconnect();
    window.removeEventListener("resize", this.handleResize);
  }
};
__decorateClass([
  queryAll("[data-tab]")
], CommonMainProduct.prototype, "tabs", 2);
__decorateClass([
  queryAll("[data-tab-panel]")
], CommonMainProduct.prototype, "panels", 2);
__decorateClass([
  onClick("[data-tab]")
], CommonMainProduct.prototype, "handleTabClick", 1);
__decorateClass([
  onClick("[data-show-more]")
], CommonMainProduct.prototype, "handleShowMoreClick", 1);
CommonMainProduct = __decorateClass([
  defineElement("common-main-product")
], CommonMainProduct);
export {
  CommonMainProduct
};
